


interface OrderChangedIconProps {
	className?: string,
}


const OrderChangedIcon = (props: OrderChangedIconProps) => {
	const { className } = props;

	return (
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fas"
			data-icon="custom-order-changed-icon"
			className={`svg-inline--fa fa-custom-order-changed-icon${className ? ` ${className}` : ''}`}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 333 512">
			<path fill="currentColor" d="m97.71,80.09c4,-23.23 21.62,-40.05 41.85,-40.05l48.06,0c20.22,0 38.04,17.02 41.85,40.25l3.6,21.22l40.65,0l-4.81,-28.03c-7.21,-42.65 -41.45,-73.48 -81.49,-73.48l-48.06,0c-39.85,0 -74.09,30.84 -81.29,73.48l-4.81,28.03l40.65,0l3.6,-21.22l0.2,-0.2z"/>
			<path fill="currentColor" d="m123.94,327.38l0,27.03c9.21,0 18.42,-0.2 27.63,-0.4l-27.23,-27.23s-0.4,0.4 -0.6,0.6l0.2,0z"/>
			<path fill="currentColor" d="m296.54,111.53l-260.3,0c-20.02,0 -36.24,16.22 -36.24,36.24l0,327.78c0,20.02 16.22,36.24 36.24,36.24l260.3,0c20.02,0 36.24,-16.22 36.24,-36.24l0,-327.78c0,-20.02 -16.22,-36.24 -36.24,-36.24zm-142.56,167.19c14.62,-15.22 29.23,-30.44 43.85,-45.65c2.2,-2.4 6.21,-2.2 8.41,0c12.01,12.01 24.03,24.03 36.04,36.04c2.4,2.4 2.2,6.21 0,8.41c-5.81,6.01 -11.41,12.01 -17.22,17.82c-19.42,20.22 -39.05,40.45 -58.47,60.67c-4.61,4.81 -7.61,9.61 -14.62,9.81l-34.64,0.6c-3.6,0 -5.41,-2.6 -5.61,-5.21c0,-0.2 -0.4,-0.4 -0.4,-0.8l0,-17.82c0,-5.81 -0.8,-12.01 0,-17.82c0.8,-6.01 9.01,-11.81 13.02,-15.82c9.81,-10.21 19.62,-20.22 29.43,-30.44l0.2,0.2zm97.31,117.94c0,3.2 -2.8,6.01 -6.01,6.01l-164.59,0c-3.2,0 -6.01,-2.8 -6.01,-6.01l0,-164.79c0,-3.2 2.8,-6.01 6.01,-6.01l36.24,0c7.81,0 7.81,12.01 0,12.01l-30.23,0l0,152.78l152.78,0l0,-34.24c0,-7.81 12.01,-7.81 12.01,0l0,40.25l-0.2,0z"/>
			<path fill="currentColor" d="m161.19,344.8c22.83,-23.83 45.85,-47.66 68.68,-71.48l-27.63,-27.63c-2.2,2.2 -4.2,4.41 -6.41,6.61c-22.03,22.83 -44.05,45.65 -66.08,68.48l27.63,27.63c1.2,-1.2 2.4,-2.6 3.6,-3.8l0.2,0.2z"/>
		</svg>
	);
};

export default OrderChangedIcon;